/**
 * Used for maintaining the position of entities when they are moved, for
 * collisions.
 *
 * @type {Map<number, Map<number, { x: number; y: number }>>}
 */
export const last_entity_positions = new Map()
